<ng-container *transloco="let t;">
    <div class="pb-50 mt-0 mb-0 docFieldWrapper pb-1" *ngIf="!field?.hidden" [ngbTooltip]="t('Permission toaster text (General) - You dont have permission to edit this field')" [disableTooltip]="canEdit">
        <div class="d-flex justify-content-start align-items-center" [ngClass]="{'pinIcon': field?.pinned_field}">
            <label *ngIf="!field?.hidden" class="col-form-label font-small-3 ellipse-text p-0" [for]="field?.select_type_text" [ngClass]="{'text-danger': field?.field_invalid === 1}" triggers="hover">
                {{ field?.select_type_text }} 
                @if(field?.field_section === "document_field" && field?.description && field?.description !== 'null'){
                    <i class="feather icon-alert-circle ms-25" placement="top" container="body" placement="auto" [autoClose]="true" triggers="hover" [ngbTooltip]="field?.description"></i>
                }
            </label>
        </div>
        <div class="fields-container position-relative">
            <div class="fields-section">
                <!-- For the textField -->
                @if(field.type === 'text' && !field.hidden){ @if(field.allow_multi_lines === 1){
                <textarea
                    class="form-control font-small-3 meta-data-multi-field"
                    [id]="field.select_type_text"
                    [attr.uuid]="field.uuid"
                    rows="2"
                    [value]="field?.value ?? ''"
                    (input)="syncDocumentTextfield($event, field)"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    (blur)="syncDocumentTextfield($event, field)"
                    [placeholder]="field.placeholder ?? field.select_type_text"
                    [disabled]="field.enable_calculation === 1 || (disabledRecipientField || shouldFieldDisabled)"
                >
                    {{field.value}}
                </textarea>
                } @else{
                <input
                    type="text"
                    class="form-control font-small-3 edit-template-right-menu-fields"
                    [id]="field.select_type_text"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    [attr.uuid]="field.uuid"
                    [value]="field?.value ?? ''"
                    (focus)="getSuggestions($event, field)"
                    (input)="syncDocumentTextfield($event, field)"
                    (blur)="syncDocumentTextfield($event, field)"
                    [placeholder]="field.placeholder ?? field.select_type_text"
                    [disabled]="field.enable_calculation === 1 || (disabledRecipientField || shouldFieldDisabled)"
                />
                } }
                <!-- For the datepicker -->
                <input
                    *ngIf="field.type === 'datepicker'"
                    type="text"
                    mwlFlatpickr
                    class="form-control font-small-3 docfield_datePicker"
                    [altInput]="true"
                    [altFormat]="(false | userTimeZoneFormat) | async"
                    [value]="field.value"
                    [convertModelValue]="true"
                    (change)="syncDocumentDatepickerfield($event, field)"
                    [ngModelOptions]="{standalone: true}"
                    [monthSelectorType]="flatpickrDefaultInterFace.monthSelectorType"
                    [placeholder]="field.placeholder ?? field.select_type_text"
                    [disabled]="field.enable_calculation === 1 || (disabledRecipientField || shouldFieldDisabled)"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    readonly="readonly"
                    [ngModel]="field['value'] || null"
                    (flatpickrOpen)="onReadyDatepicker($event)"
                />

                <!-- For the droplist -->
                <ng-select
                    #droplistForDocumentFeild
                    *ngIf="(field.type === 'droplist' && (!field['multi_select'] || field['multi_select'] === 0)) && (!field.hidden || field.hidden === 0)"
                    [placeholder]='field?.placeholder ?? t("Content droplist select option (Template/Document - section) - Select option")'
                    [ngModel]="field['value'] || null"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    [disabled]="(disabledRecipientField || shouldFieldDisabled)"
                    (change)="syncDocumentDroplistField($event, field)"
                    [clearable]="false"
                >
                    <ng-option [value]="''">
                        {{field?.placeholder ?? t("Content droplist select option (Template/Document - section) - Select option")}}
                    </ng-option>

                    <!-- Loop through options and apply styles conditionally -->
                    <ng-container *ngFor="let option of field['options'] | flattenOptions; trackBy: trackOption">
                        <ng-option *ngIf="option.hide !== 1 && option.value" [value]="option.value">
                            <span [ngClass]="{ 'font-small-3': option.level > 0 }" [style.padding-left.px]="option.level * 15">
                                {{ option.name }}
                            </span>
                        </ng-option>
                    </ng-container>
                    <!-- Custom template for selected value -->
                    <ng-template ng-label-tmp let-selected="selected">
                        <span>{{field['value'] || null | getDroplistName : field}}</span>
                        <!-- Added optional chaining to prevent errors if selected is undefined -->
                    </ng-template>
                </ng-select>

                <!-- Multi select droplist -->
                <ng-select
                    *ngIf="(field.type === 'droplist' && field['multi_select'] === 1) && !field.hidden"
                    [placeholder]='field?.placeholder || t("Content droplist select option (Template/Document - section) - Select option")'
                    [ngModel]="field['value'] || null"
                    (change)="syncMultiSelectField($event, field)"
                    [clearable]="false"
                    [closeOnSelect]="false"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    [disabled]="(disabledRecipientField || shouldFieldDisabled)"
                    [multiple]="true"
                >
                    <ng-option [value]="''">{{field?.placeholder || t("Content droplist select option (Template/Document - section) - Select option")}}</ng-option>
                    @for (option of field['options'] | flattenOptions; track option.id) { 
                        @if (option.hide != 1 && option.value) {
                            <ng-option [value]="option.value">
                                <span [ngClass]="{'child-option': option.level === 1, 'grand-child-option': option.level === 2}">
                                    {{option.name}}
                                </span>
                            </ng-option>
                        }
                    }
                </ng-select>

                <ng-select
                    *ngIf="(field.type === 'list') && !field.hidden"
                    [placeholder]='field?.placeholder || t("Content droplist select option (Template/Document - section) - Select option")'
                    [ngModel]="(field['value'] || null)"
                    (change)="syncDocumentListField($event, field)"
                    [clearable]="false"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    [disabled]="(disabledRecipientField || shouldFieldDisabled)"
                    [closeOnSelect]="(field['multi_choice'] === 1) ? false : true"
                    [multiple]="field['multi_choice'] === 1 ? true : false"
                >
                    <ng-option [value]="''">{{t("Content droplist select option (Template/Document - section) - Select option")}}</ng-option>
                    @for (option of field['options']; track option.id) { @if (option.hide != 1 && option.value) {
                    <ng-option [value]="option.value">{{option.name}}</ng-option>
                    } }
                </ng-select>

                <!-- For the multi choice -->
                <ng-select
                    #checkBoxFieldDetailTab
                    [ngModelOptions]="{standalone: true}"
                    *ngIf="field.type === 'checkbox' && !field.hidden"
                    [placeholder]="t('Select option (general) - Select option')"
                    [ngModel]="(field['value'] || 0)"
                    [items]="checkBoxField"
                    (change)="syncDocumentCheckboxField($event, field)"
                    [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                    [disabled]="(disabledRecipientField || shouldFieldDisabled)"
                    bindLabel="name"
                    bindValue="value"
                    [clearable]="false"
                    [searchable]="false"
                >
                    <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                       <ng-option [value]="''">{{field?.placeholder ?? t("Select option (general) - Select option")}}</ng-option>
                        <div *ngIf="item.hide !== 1">
                            <div class="">
                                <span class="">{{ item.name }}</span>
                            </div>
                        </div>
                    </ng-template>
                </ng-select>
            </div>

            <div class="docFieldIconContainer" *ngIf="(documentData | isDocumentEditable)">
                <ng-container *ngIf="canLock">
                    <i class="feather icon-unlock docFieldIcon cursor-pointer"
                       container="body"
                       placement="top"
                       (click)="setFieldLock(1)"
                       [ngbTooltip]="t('Lock icon tooltip text (Edit template settings - Secret fields) - Lock field')">
                    </i>
                  </ng-container>
                  
                  <ng-container *ngIf="canUnlock">
                    <i class="feather docFieldIcon icon-lock cursor-pointer"
                       container="body"
                       placement="top"
                       (click)="setFieldLock(0)"
                       [ngbTooltip]="t('Unlock icon tooltip text (Edit template settings - Secret fields) - Unlock field')">
                    </i>
                  </ng-container>
                  
                  <ng-container *ngIf="isNotPresent">
                    <i class="feather icon-eye-off docFieldIcon cursor-pointer"
                       container="body"
                       placement="top"
                       [ngbTooltip]="eyeOffTooltip">
                    </i>
                  </ng-container>

                  <ng-container *ngIf="_enableFieldSettings">
                    <i class="feather icon-sliders docFieldIcon cursor-pointer"
                       container="body"
                       placement="top"
                       [ngbTooltip]="t('Box three dot menu option (Template/Document - section) - Setting')"
                       (click)="openFieldSettings(field)"
                       >
                    </i>
                  </ng-container>

                  <ng-container *ngIf="isFieldAssignedToRecipient">
                    <i class="feather icon-info docFieldIcon cursor-pointer"
                       container="body"
                       placement="auto"
                       [ngbTooltip]="field?.selected_for_role_id | findRecipientRoleById"
                       >
                    </i>
                  </ng-container>
                  
                  <ng-container *ngIf="canDelete">
                    <i class="feather icon-trash docFieldIcon cursor-pointer"
                        [ngClass]="{'text-danger': !field?.pinned_field, 'text-secondary': field?.pinned_field === 1}"
                       container="body"
                       placement="top"
                       (click)="deleteField(field)"
                       [ngbTooltip]="t('Delete icon tooltip text (Edit template settings - Secret fields) - Delete field')">
                    </i>
                  </ng-container>
                  
                <span *ngIf="!field.hidden && !field.secret_hidden_field" placement="auto" ngbTooltip="Sort" container="body">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-menu docFieldSortIcon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        stroke-width="1.3"
                        stroke="#2c3e50"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 8l16 0" />
                        <path d="M4 16l16 0" />
                    </svg>
                </span>
            </div>
        </div>
    </div>
</ng-container>